import { wrapImageOverlayer, FocusHandler } from './Component';

export * from './Component';
export * from './hooks';
export * from './helpers';

export default {
  setup({ app }) {
    app.extension.wrapElement('image', { overlayer: wrapImageOverlayer });
    app.extension.registerComponent('root', { Component: FocusHandler });
  },
};
